import { Component } from "@angular/core";
import { NavController, ModalController, AlertController } from "ionic-angular";
import { AngularFire, FirebaseListObservable } from "angularfire2";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";

import { User } from "../user/user";

import { Matcher } from "../../utils/matcher";

import moment from "moment";
import orderBy from "lodash/orderBy";
import take from "lodash/take";
import inRange from "lodash/inRange";

@Component({
  selector: "page-users",
  templateUrl: "users.html",
})
export class Users {
  // regex
  pattern = new Matcher();

  // data
  subscription: any = null;
  isLoaded: boolean = false;
  users: FirebaseListObservable<any[]>;
  searchResults: Observable<any[]>;

  constructor(
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public alertCtrl: AlertController,
    public af: AngularFire,
  ) {
    this.users = this.af.database.list("/users");
    this.subscription = this.users.subscribe(data => {
      this.isLoaded = true;
      this.getUsers({ target: { value: "*" } });
    });

    // (<any>firebase).database.ServerValue.TIMESTAMP
    // this.users.update('/wjDLHIbdFrdmlVnH2vqjVB0KAFi1', {
    //     id: 'wjDLHIbdFrdmlVnH2vqjVB0KAFi1',
    //     username: 'juan',
    //     email: 'juanluis.suarez@gmail.com',
    //     usertype: 'student',
    //     school: 'Hamilton Boys\' High School',
    //     deviceId: 'b130fcd6-907f-4535-b8d9-0dec923d52f0',
    //     timestamp: moment().unix(),
    //     relationship: { trust: 15, violence: 11, emotions: 9, safety: 8, honesty: 5 },
    //     emotions: { happy: 3, confused: 11, sad: 2, jealous: 1, angry: 3 },
    //     health: { initial: 1, current: 4 },
    //     state: 'active'
    // });
  }

  ionViewDidLoad() {}

  showAlert(message: string) {
    let alert = this.alertCtrl.create({
      title: "Harmonised",
      subTitle: message,
      buttons: ["OK"],
    });
    alert.present();
  }

  checkTimestamp(ts: number, fromDate: number, toDate?: number) {
    if (!fromDate) {
      return true;
    }

    if (toDate) {
      return inRange(ts, fromDate, toDate);
    } else {
      return inRange(ts, fromDate, moment().unix());
    }
  }

  getUsers(event: any) {
    let val = event.target.value;
    let query: any = this.pattern.match(
      "<value> <from> <to> <order> <limit>",
      "string date date order number",
      val,
    );
    if (!query.value || query.value === "*") {
      query.value = "";
    } else {
      query.value = query.value.toLowerCase();
    }
    console.log("getUsers - query", JSON.stringify(query));

    // this.searchResults = take( orderBy( filter(this.users, query.value), ['timestamp'], [query.order]), query.limit);
    this.searchResults = this.users.map((data: any) => {
      let results = [];
      data.map(item => {
        if (
          JSON.stringify(item)
            .toLowerCase()
            .includes(query.value) &&
          this.checkTimestamp(item.timestamp, query.from, query.to)
        ) {
          results.push(item);
        }
      });
      results = take(
        orderBy(results, ["timestamp"], [query.order || "desc"]),
        query.limit || results.length,
      );
      return results;
    });
  }

  onLogout() {
    this.subscription.unsubscribe();
    this.af.auth.logout();
  }

  onEdit(user: any) {
    let editModal = this.modalCtrl.create(User, { user: user });
    editModal.present();
  }

  onExport() {
    this.showAlert("Coming Soon!");
  }
}



// WEBPACK FOOTER //
// ./src/pages/users/users.ts